import * as Yup from 'yup';
import AllForm from '../../Stateless/Form';
import {
  Box,
  Button,
  CircularProgress,
} from '@mui/material';

import { useThemeColors } from '../../../hooks/useThemeColors';
import {
  UseCreateDeliveryManager,
  useEditDeliveryManager,
} from '../../Query/DeliveryManagerQuery';
import { useAtom } from 'jotai';
import { deliveryManagerAtom } from './AdminDeliveryManagerTable';
import { useState } from 'react';
import PhoneNumberInput from '../Utils/PhoneNumberInput';
import { FieldInputProps, FormikProps } from 'formik';
import ImageUploadField from '../Utils/ImageUploadField';
import {COLORS} from "../../../theme/themeConstants"
const validationSchema = Yup.object().shape({
  name: Yup.string()
    .required('Please enter Name ')
    .matches(/^[A-Za-z\s]+$/, 'Name should only contain letters and spaces')
    .max(100, 'Item Name cannot exceed 50 characters')
    .test(
      'not-only-spaces',
      'Name cannot be only spaces',
      (value) => {
        if (typeof value !== 'string') return false;
        return value.trim().length > 0;
      }
    ),
  password: Yup.string()
    .required('Please enter the password')
    .min(8, 'Password must be at least 8 characters')
    .max(15, 'Password must not exceed 15 characters')
    .matches(/^\S*$/, 'Password cannot contain spaces'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), ''], 'Passwords must match')
    .required('Please enter the confirm password')
    .min(8, 'Password must be at least 8 characters')
    .max(15, 'Password must not exceed 15 characters')
    .matches(/^\S*$/, 'Password cannot contain spaces'),
  email: Yup.string()
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,3}$/,
      'Please enter a valid email address'
    )
    .required('Email is required'),
  mobile: Yup.string()
    .required('Please enter the mobile number')
    .matches(/^[0-9]+$/, 'Mobile number should contain only numbers')
    .test(
      'len',
      'Mobile number must be 9 digits or more',
      (val) => val?.length >= 9
    )
    .notOneOf(['0000000000'], 'Mobile number cannot be all zeroes'),
  profilePhoto: Yup.mixed()
    .required('Restaurant logo is required')
    .test('fileSize', 'Logo must be less than 500kb', (value: any) => {
      if (!value || typeof value === 'string') return true;
      return value.size <= 500000;
    })
    .test(
      'dimensions',
      'Logo must be between 300x300px and 500x500px',
      (value: any): Promise<boolean> => {
        if (!value || !(value instanceof File)) return Promise.resolve(true);

        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = (e) => {
            const img = new Image();
            img.src = e.target?.result as string;

            img.onload = () => {
              const { width, height } = img;
              if (
                width >= 300 &&
                height >= 300 &&
                width <= 500 &&
                height <= 500
              ) {
                resolve(true);
              } else {
                resolve(false);
              }
            };

            img.onerror = () => resolve(false);
          };
          reader.readAsDataURL(value);
        });
      }
    ),
});


const AddDeliveryManager = ({ onCancel }: { onCancel: () => void }) => {
  const [DeliveryManagerData] = useAtom(deliveryManagerAtom);
  console.log('DeliveryManagerData', DeliveryManagerData);
  const { warning } = useThemeColors();
  const [selectedCountryCode, setSelectedCountryCode] = useState('+962');
  const {
    mutate: CreateDeliveryManager,
    isPending: CreateDeliveryManagerLoading,
  } = UseCreateDeliveryManager();

  const { mutate: EditDeliveryManager, isPending: EditDeliveryManagerLoading } =
    useEditDeliveryManager();
  return (
    <>
      {AllForm({
        initialValues: {
          name: DeliveryManagerData ? DeliveryManagerData?.name : '',
          password: DeliveryManagerData ? DeliveryManagerData?.password : '',
          confirmPassword: DeliveryManagerData
            ? DeliveryManagerData?.confirmPassword
            : '',
          email: DeliveryManagerData ? DeliveryManagerData?.email : '',
          mobile: DeliveryManagerData
            ? String(DeliveryManagerData?.mobileNumber)?.slice(selectedCountryCode?.length)
            : null,
          profilePhoto: DeliveryManagerData
            ? DeliveryManagerData?.profilePhoto
            : '',
        },
        validateOnChange: true,
        validateOnBlur: true,
        validationSchema,
        onSubmit: async (values: any) => {
          const modifiedValues = {
            ...values,
            name: values.name,
            email: values.email,
            password: values.password,
            mobileNumber: `${selectedCountryCode}${values.mobile}`,
          };
          console.log(modifiedValues);
          // CreateDeliveryManager(modifiedValues, {
          //   onSuccess: () => {},
          //   onError: (error: any) => {
          //     console.error('choice error:', error);
          //   },
          // });
          try {
            if (DeliveryManagerData) {
              EditDeliveryManager(
                {
                  id: DeliveryManagerData.id || '',
                  data: modifiedValues,
                },
                {
                  onSuccess: () => {
                    onCancel();
                    // closeForm();
                    // resetForm();
                  },
                  onError: (error: any) => {
                    console.log(error);
                    // setErrors(parseJavaError(error));
                  },
                }
              );
            } else {
              CreateDeliveryManager(modifiedValues, {
                onSuccess: () => {
                  onCancel();
                  // closeForm();
                  // resetForm();
                },
                onError: (error: any) => {
                  console.log(error);
                  // setErrors(parseJavaError(error));
                },
              });
            }
          } catch (error) {
            console.log(error);
            // setErrors(parseJavaError(error));
          }
        },

        fields: [
          {
            name: 'name',
            label: 'Name:',
            type: 'text',
            isRequired: true,
          },
          {
            name: 'email',
            label: 'Email ID:',
            type: 'text',
            isRequired: true,
          },
          {
            name: 'password',
            label: 'Password:',
            type: 'password',
            isRequired: true,
          },
          {
            name: 'confirmPassword',
            label: 'Confirm Password:',
            type: 'password',
            isRequired: true,
          },
          {
            name: 'mobile',
            label: 'Phone:',
            type: 'custom',
            isRequired: true,
            component: ({
              field,
              form,
            }: {
              field: FieldInputProps<any>;
              form: FormikProps<any>;
            }) => (
              <PhoneNumberInput
                field={field}
                form={form}
                selectedCountryCode={selectedCountryCode}
                onCountryCodeChange={setSelectedCountryCode}
              />
            )
          },
          // {
          //   name: 'profilePhoto',
          //   label: 'Profile Photo:',
          //   type: 'file',
          //   isRequired: true,
          //   component: ({ field, form }: any) => (
          //     <FormControl
          //       error={
          //         form.touched[field.name] && Boolean(form.errors[field.name])
          //       }
          //       fullWidth
          //     >
          //       <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
          //         <Box sx={{ flex: 1 }}>
          //           <input
          //             type="file"
          //             accept="image/*"
          //             id="restaurant-logo"
          //             style={{ display: 'none' }}
          //             onChange={async (
          //               e: React.ChangeEvent<HTMLInputElement>
          //             ) => {
          //               const file = e.target.files?.[0] || null;
          //               form.setFieldTouched(field.name, true);

          //               if (!file) return;

          //               if (file.size > 500000) {
          //                 form.setFieldError(
          //                   field.name,
          //                   'Logo must be less than 500kb'
          //                 );
          //                 return;
          //               }

          //               const isValidDimensions = await new Promise<boolean>(
          //                 (resolve) => {
          //                   const reader = new FileReader();
          //                   reader.onload = (ev) => {
          //                     const img = new Image();
          //                     img.src = ev.target?.result as string;
          //                     img.onload = () => {
          //                       const { width, height } = img;
          //                       resolve(
          //                         width >= 300 &&
          //                         height >= 300 &&
          //                         width <= 500 &&
          //                         height <= 500
          //                       );
          //                     };
          //                     img.onerror = () => resolve(false);
          //                   };
          //                   reader.readAsDataURL(file);
          //                 }
          //               );

          //               if (!isValidDimensions) {
          //                 form.setFieldError(
          //                   field.name,
          //                   'Logo must be between 300×300px and 500×500px'
          //                 );
          //                 return;
          //               }

          //               try {
          //                 // ✅ Upload to S3
          //                 const { url } = await uploadImage(file); // <-- You already have this function
          //                 form.setFieldValue(field.name, url);
          //                 form.setFieldError(field.name, undefined);
          //                 form.validateField(field.name);
          //               } catch (error) {
          //                 console.log(error);
          //                 form.setFieldError(
          //                   field.name,
          //                   'Upload failed. Please try again.'
          //                 );
          //               }
          //             }}
          //           />

          //           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          //             <label htmlFor="restaurant-logo">
          //               <Button
          //                 variant="outlined"
          //                 component="span"
          //                 sx={{
          //                   textTransform: 'uppercase',
          //                   height: '35px',
          //                   bgcolor: 'background.paper',
          //                   color: 'black',
          //                   borderColor: 'black',
          //                   '&:hover': {
          //                     borderColor: 'black',
          //                     backgroundColor: 'rgba(0, 0, 0, 0.04)',
          //                   },
          //                 }}
          //               >
          //                 Choose File
          //               </Button>
          //             </label>

          //             <Typography variant="body2" color="text.secondary">
          //               {field.value ? 'File selected' : 'No file chosen'}
          //             </Typography>

          //             {field.value && (
          //               <Button
          //                 variant="contained"
          //                 color="error"
          //                 onClick={() => {
          //                   form.setFieldValue(field.name, null);
          //                   form.setFieldError(field.name, undefined);
          //                 }}
          //                 sx={{
          //                   height: '30px',
          //                   textTransform: 'uppercase',
          //                 }}
          //               >
          //                 Clear
          //               </Button>
          //             )}
          //           </Box>

          //           {/* ✅ Preview for base64 or URL */}
          //           {field.value && typeof field.value === 'string' && (
          //             <Box mt={1}>
          //               <img
          //                 src={field.value}
          //                 alt="Restaurant Logo"
          //                 style={{ maxWidth: 150, maxHeight: 150 }}
          //               />
          //             </Box>
          //           )}

          //           <Typography
          //             variant="caption"
          //             color="text.secondary"
          //             sx={{ display: 'block', mt: 0.5 }}
          //           >
          //             (Min 300×300px & Max 500×500px)
          //           </Typography>

          //           {/* {form.touched[field.name] && form.errors[field.name] && (
          //               <Typography variant="caption" color="error">
          //                 {form.errors[field.name]}
          //               </Typography>
          //             )} */}
          //         </Box>
          //       </Box>
          //     </FormControl>
          //   ),
          // },
          {
            name: 'profilePhoto',
            label: 'Profile Photo:',
            type: 'file',
            isRequired: true,
            component: () => (
              <ImageUploadField
                name="profilePhoto"
                label="logo"
              />
            )
          },
        ],

        customButton: (formikProps: any) => (
          <Box sx={{ display: 'flex', gap: 2 }}>
            {/* <Button
          type="submit"
          variant="contained"
          sx={{
            textTransform: 'none',
            fontSize: 14,
            px: 3,
            py: 1,
            backgroundColor: 'rgb(76, 10, 39)',
            '&:hover': {
              backgroundColor: 'rgb(76, 10, 39, 0.8)',
            },
            '&:disabled': {
              backgroundColor: 'rgba(0, 0, 0, 0.12)',
              color: 'rgba(0, 0, 0, 0.26)',
            },
          }}
          onClick={() => formikProps.handleSubmit()}
          >
          {DeliveryManagerData ? 'Update' : 'Create'}
        </Button> */}
            <Button
              type="submit"
              variant="contained"
              sx={{
                textTransform: 'none',
                fontSize: 14,
                px: 3,
                py: 1,
                backgroundColor: COLORS.primary.main,
                '&:hover': {
                  backgroundColor: COLORS.primary.dark,
                },
                '&:disabled': {
                  backgroundColor: 'rgba(0, 0, 0, 0.12)',
                  color: 'rgba(0, 0, 0, 0.26)',
                },
              }}
              onClick={(e) => {
                e.preventDefault();
                // Mark all fields as touched to show validation errors
                Object.keys(formikProps.values).forEach((fieldName) => {
                  formikProps.setFieldTouched(fieldName, true, false);
                });
                // Check if there are validation errors
                if (Object.keys(formikProps.errors).length === 0) {
                  formikProps.handleSubmit();
                } else {
                  console.log('Validation failed:', formikProps.errors);
                }
              }}
              disabled={
                CreateDeliveryManagerLoading || EditDeliveryManagerLoading
              }
            >
              {CreateDeliveryManagerLoading || EditDeliveryManagerLoading ? (
                <>
                  <CircularProgress size={16} sx={{ color: '#fff', mr: 1 }} />
                  {DeliveryManagerData ? 'Updating...' : 'Creating...'}
                </>
              ) : DeliveryManagerData ? (
                'Update'
              ) : (
                'Create'
              )}
            </Button>

            {!DeliveryManagerData && (
              <Button
                type="button"
                variant="outlined"
                onClick={() => formikProps.resetForm()}
                sx={{
                  textTransform: 'none',
                  fontSize: 14,
                  px: 3,
                  py: 1,
                  borderColor: COLORS.secondary.main,
                  color: COLORS.secondary.main,
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  },
                  '&:disabled': {
                    backgroundColor: 'rgba(0, 0, 0, 0.12)',
                    color: 'rgba(0, 0, 0, 0.26)',
                  },
                }}
              >
                Reset
              </Button>
            )}
            <Button
              type="button"
              variant="outlined"
              color="error"
              onClick={onCancel}
              sx={{
                bgcolor: warning.main,
                color: '#fff',
                '&:hover': {
                  bgcolor: warning.dark,
                  color: '#fff',
                },
              }}
            >
              Cancel
            </Button>
          </Box>
        ),
      })()}
    </>
  );
};

export default AddDeliveryManager;
